
/**
 * Utility functions for handling text in charts
 */

export const wrapText = (text: string, maxLength: number = 15): string => {
  if (text.length <= maxLength) return text;
  
  // Common break points for better readability
  const breakWords = ['of', 'and', 'on', 'in', 'at', 'for', 'the', 'to'];
  const words = text.split(' ');
  
  if (words.length === 1) {
    // Single long word - break at reasonable point
    return text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text;
  }
  
  // Find good break point
  let firstLine = '';
  let secondLine = '';
  let breakFound = false;
  
  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const testLine = firstLine + (firstLine ? ' ' : '') + word;
    
    if (testLine.length <= maxLength || i === 0) {
      firstLine += (firstLine ? ' ' : '') + word;
    } else {
      // Check if current word is a good break word
      if (breakWords.includes(word.toLowerCase()) && i < words.length - 1) {
        firstLine += ' ' + word;
        secondLine = words.slice(i + 1).join(' ');
      } else {
        secondLine = words.slice(i).join(' ');
      }
      breakFound = true;
      break;
    }
  }
  
  if (!breakFound || !secondLine) {
    return text.length > maxLength ? `${text.substring(0, maxLength - 3)}...` : text;
  }
  
  // Truncate second line if still too long
  if (secondLine.length > maxLength) {
    secondLine = secondLine.substring(0, maxLength - 3) + '...';
  }
  
  return `${firstLine}\n${secondLine}`;
};

export const createMultilineLabel = (text: string, maxLength: number = 15) => {
  const wrappedText = wrapText(text, maxLength);
  return wrappedText.split('\n');
};

// Custom tick component for multiline text
export const MultilineAxisTick = ({ x, y, payload, maxLength = 15, fontSize = 12 }) => {
  const lines = createMultilineLabel(payload.value, maxLength);
  
  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, index) => (
        <text
          key={index}
          x={0}
          y={index * (fontSize + 2)}
          dy={index === 0 ? 0 : 0}
          textAnchor="middle"
          fill="#666"
          fontSize={fontSize}
        >
          {line}
        </text>
      ))}
    </g>
  );
};
